import { keyframes } from 'styled-components';
import { colors } from '../styles';

export function floating() {
    return keyframes`
        from {transform: translateY(-5px);}
        to {transform: translateY(5px);}
    `;
}

export function svgColorFadeIn(fadeColor: string) {
    return keyframes`
        0% {fill: ${colors.grey300};}
        100% {fill: ${fadeColor};}
        `;
}
